/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagResource
 */
export interface TagResource {
    /**
     * 
     * @type {string}
     * @memberof TagResource
     */
    tag: string;
}

/**
 * Check if a given object implements the TagResource interface.
 */
export function instanceOfTagResource(value: object): value is TagResource {
    if (!('tag' in value) || value['tag'] === undefined) return false;
    return true;
}

export function TagResourceFromJSON(json: any): TagResource {
    return TagResourceFromJSONTyped(json, false);
}

export function TagResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagResource {
    if (json == null) {
        return json;
    }
    return {
        
        'tag': json['tag'],
    };
}

export function TagResourceToJSON(value?: TagResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tag': value['tag'],
    };
}

